import { createContext } from 'react';

export type MenuContextType = {
  closeMenu: () => void;
  variant?: 'compact';
  color?: 'light' | 'dark';
};

export const MenuContext = createContext<MenuContextType>({
  closeMenu: () => null,
});
